<template>
    <div>
        <el-carousel ref="carousel" :interval="5000" height="346px" :initial-index="curIndex" :autoplay="autoplay"
            @change="changeCarousel" indicator-position="none" class="index-active-carousel">
            <el-carousel-item class="carousel-item" v-for="item in associationList" :key="item.id">
                <img :src="item.image" alt="" @click="gotoDetails(item)" />
            </el-carousel-item>
        </el-carousel>
        <div class="carousel-tab flex">
            <div v-for="(item, index) in associationList" :key="item.id" @click="clickTab(index)">
                <img :src="item.image" alt="" @mouseenter="mouseenter(index)" @mouseleave="mouseleave(index)"
                    @click="gotoDetails(item)" />
            </div>
        </div>
        <div v-if="curItem" @click="gotoDetails(curItem)">
            <p class="flex">
                <span class="line-one-ellipsis">{{ curItem.title }}</span>{{ curItem.createtimedate }}
            </p>
            <p class="desc">{{ curItem.introduce }}</p>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        associationList: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data() {
        return {
            curIndex: 0,
            autoplay: true,
        };
    },
    computed: {
        curItem() {
            return this.associationList[this.curIndex];
        },
    },
    methods: {
        changeCarousel(curIndex) {
            this.curIndex = curIndex;
        },
        clickTab(e) {
            this.$refs.carousel.setActiveItem(e);
        },
        gotoDetails(e) {
            if (e.url !== '' ) {
                window.open(e.url, "_blank");
            } else {
                this.$router.push({
                    path: "/news/16/detail",
                    query: { id: e.id,categoryId:e.category_id},
                });
            }
            // return
            // this.$router.push({
            //     path: "/news/16/detail",
            //     query: { id: id },
            // });
        },
        mouseenter(index) {
            this.$refs.carousel.setActiveItem(index);
            this.autoplay = false;
        },
        mouseleave() {
            this.autoplay = true;
        },
    },
};
</script>

<style scoped>
.index-active-carousel img {
    width: 100%;
    height: 100%;
}

.carousel-item {
    border-radius: 5px;
}

.index-active-carousel ::v-deep .el-carousel__container .el-carousel__arrow {
    border-radius: 0;
    width: 30px;
    height: 31px;
}

.index-active-carousel ::v-deep .el-carousel__container .el-carousel__arrow--right {
    right: 22px;
    background: url(@/assets/images/index-right-next.png);
    background-size: 100%;
}

.index-active-carousel ::v-deep .el-carousel__container .el-carousel__arrow--left {
    left: 22px;
    background: url(@/assets/images/index-left-prev.png);
    background-size: 100%;
}

.index-active-carousel ::v-deep .el-icon-arrow-left,
.index-active-carousel ::v-deep .el-icon-arrow-right {
    display: none;
}

.carousel-tab {
    margin-top: 15px;
    margin-bottom: 18px;
}

.carousel-tab img {
    width: 96px;
    height: 65px;
    border-radius: 8px;
}

p {
    color: #6c6b76;
    font-size: 14px;
    align-items: center;
}

p span {
    font-size: 18px;
    font-weight: bold;
    color: #121126;
}

.desc {
    font-size: 13px;
    margin-top: 10px;
}
</style>
